import { render, staticRenderFns } from "./CmsFileFrame.vue?vue&type=template&id=1d0d94f9&scoped=true&"
import script from "./CmsFileFrame.vue?vue&type=script&lang=js&"
export * from "./CmsFileFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0d94f9",
  null
  
)

export default component.exports